import { proxy, useSnapshot } from "valtio";
import { EnumLeverageProductsIndication } from "src/api/client/extended-search.api";
import { IKeyFigureValue, ISelectedRanking, ITagValue } from "src/components/pages/search/components/types";
import { ISortDirectionType } from "src/types/common";

export type ISearchStore = typeof searchStore;

export const searchStore = proxy({
    query: "",
    keyFigures: [] as ReadonlyArray<IKeyFigureValue>,
    tags: [] as ReadonlyArray<ITagValue>,
    selectedRanking: {} as ISelectedRanking,
    sortDirection: null as ISortDirectionType,
    brokersIds: [] as ReadonlyArray<string>,
    isInvestable: true,
    isAtInvestable: true,
    isChInvestable: true,
    leverageProductsIndication: EnumLeverageProductsIndication.AllWikifolios,
});

export function useSearchStore() {
    return useSnapshot(searchStore);
}
